import React, { useContext } from 'react';
import { ProductContext } from './ProductContext';
import LanguageSwitcher from './LanguageSwitcher';
import HamburgerMenu from './HamburgerMenu';
import './Navbar.css';

function Navbar() {
  
  const { products, selectedLanguage } = useContext(ProductContext); 

  if (!products || products.length === 0) return null;

  return (
    <nav className="Navbar">
      <div className="navbar-container">
        <div className="navbar-menu">
          <HamburgerMenu />
        </div>
        <div className="navbar-language">
          <LanguageSwitcher selectedLanguage={selectedLanguage} /> 
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
